/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {} from 'react-native';
import Reanimated from 'react-native-reanimated';
import { IRotateOutDownRightPresentationProps } from './';

export const RotateOutDownRightPresentation: React.FC<IRotateOutDownRightPresentationProps> =
  (props) => {
    return (
      <Reanimated.View onLayout={props.onLayout} style={props.containerStyle}>
        {props.children}
      </Reanimated.View>
    );
  };
